import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faq';

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14">
          <div className="lg:col-span-4 flex flex-col gap-4">
            <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-question-line" aria-hidden="true" />
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              关于频道、专题与投稿的常见疑问
            </h2>
            <p className="text-sm md:text-base leading-relaxed text-foreground-600">
              第一次访问网站时，读者最常问的几个问题都整理在这里。如果还有疑问，欢迎通过联系表单告诉我们。
            </p>
            <Link
              to="/about#submit"
              className="inline-flex w-fit items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-customer-service-2-line" aria-hidden="true" />
              联系编辑部
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={faqs} />
          </div>
        </div>
      </div>
    </section>
  );
}